<ng-container *transloco="let t; read: 'formFieldNumber'">
  <ng-container *ngIf="field.readonly === true">
    <crm-row>
      <header>{{ field.name }}</header>
      <main>{{ readonlyValue$ | async }}</main>
    </crm-row>
  </ng-container>

  <ng-container *ngIf="!field.readonly" [formGroup]="parentFormGroup">
    <mat-form-field class="form-field">
      <mat-label>{{ field.name }}</mat-label>
      <input
        type="number"
        matInput
        [formControlName]="field.key"
        [min]="min"
        [max]="max"
        [required]="parentFormGroup.get(field.key).errors?.required"
      />

      <mat-error [ngxErrors]="field.key" #error="ngxErrors">
        <span ngxError="required">{{ t('requiredField') }}</span>
        <span ngxError="min">
          {{ t('numberMustBeAtLeast', { min: error.getError('min')?.min }) }}
        </span>
        <span ngxError="max">
          {{ t('numberMustBeNoMore', { max: error.getError('max')?.max }) }}
        </span>
        <span ngxError="integer">{{ t('numberMustBeInteger') }}</span>
        <span ngxError="backend">{{ error.getError('backend') }}</span>
      </mat-error>
    </mat-form-field>
  </ng-container>
</ng-container>
